import { BusMessage, BOOLEAN_BYTES_PER_ELEMENT, UID_SAFE_BYTES_PER_ELEMENT, MessageFactory, UID_BYTES_PER_ELEMENT, calcArrayByteLength } from "flavr-common";
import { SELECTION_STRATEGY } from "./types";
class SetSelectionStrategyBaseMessage extends BusMessage {
    get byteLength() {
        let byteLengt = Uint8Array.BYTES_PER_ELEMENT; // strategyType
        switch (this.strategy.type) {
            case SELECTION_STRATEGY.RAY_SELECT:
                byteLengt += SetSelectionStrategyForHandsMessage.RAY_BYTE_LENGTH;
                break;
            case SELECTION_STRATEGY.PROXIMITY_SELECT:
                byteLengt += SetSelectionStrategyForHandsMessage.PROXIMITY_BYTE_LENGTH;
                break;
            case SELECTION_STRATEGY.INTEN_SELECT:
                byteLengt += SetSelectionStrategyForHandsMessage.INTEN_BYTE_LENGTH;
                break;
        }
        return byteLengt;
    }
    serialization(stream) {
        var _a, _b, _c, _d, _e, _f;
        if (stream.isReading) {
            this.strategy = {
                type: SELECTION_STRATEGY.RAY_SELECT
            };
        }
        this.strategy.type = stream.uint8(this.strategy.type);
        switch (this.strategy.type) {
            case SELECTION_STRATEGY.RAY_SELECT:
                this.strategy.maxLength = stream.float32Safe((_a = this.strategy.maxLength) !== null && _a !== void 0 ? _a : 1000);
                this.strategy.visible = stream.boolean((_b = this.strategy.visible) !== null && _b !== void 0 ? _b : true);
                this.strategy.color = stream.uint32Safe((_c = this.strategy.color) !== null && _c !== void 0 ? _c : 0x06316d);
                this.strategy.headLength = stream.float32Safe((_d = this.strategy.headLength) !== null && _d !== void 0 ? _d : 0.05);
                this.strategy.headWidth = stream.float32Safe((_e = this.strategy.headWidth) !== null && _e !== void 0 ? _e : 0.01);
                break;
            case SELECTION_STRATEGY.PROXIMITY_SELECT:
                this.strategy.maxLength = stream.float32Safe(this.strategy.maxLength);
                this.strategy.showSphere = stream.boolean((_f = this.strategy.showSphere) !== null && _f !== void 0 ? _f : true);
                break;
            case SELECTION_STRATEGY.INTEN_SELECT:
                this.strategy.snappiness = stream.float32Safe(this.strategy.snappiness);
                this.strategy.stickiness = stream.float32Safe(this.strategy.stickiness);
                this.strategy.threshold = stream.float32Safe(this.strategy.threshold);
                this.strategy.coneHeight = stream.float32Safe(this.strategy.coneHeight);
                this.strategy.coneAngle = stream.float32Safe(this.strategy.coneAngle);
                break;
        }
    }
}
SetSelectionStrategyBaseMessage.RAY_BYTE_LENGTH = Float32Array.BYTES_PER_ELEMENT + // maxLength
    BOOLEAN_BYTES_PER_ELEMENT + // visible
    Uint32Array.BYTES_PER_ELEMENT + // color
    Float32Array.BYTES_PER_ELEMENT * 2; // headLength, headWidth
SetSelectionStrategyBaseMessage.PROXIMITY_BYTE_LENGTH = Float32Array.BYTES_PER_ELEMENT + BOOLEAN_BYTES_PER_ELEMENT; // maxLength + showSphere
SetSelectionStrategyBaseMessage.INTEN_BYTE_LENGTH = Float32Array.BYTES_PER_ELEMENT * 5; // snappiness stickiness threshold coneHeight coneAngle
export class SetSelectionStrategyMessage extends SetSelectionStrategyBaseMessage {
    get byteLength() {
        return (UID_BYTES_PER_ELEMENT +
            Float32Array.BYTES_PER_ELEMENT * (3 + 4) + // selectionOrigin, selectionRotation
            super.byteLength);
    }
    constructor(controllerUid, selectionOrigin, selectionRotation, strategy) {
        super();
        this.controllerUid = controllerUid;
        this.selectionOrigin = selectionOrigin;
        this.selectionRotation = selectionRotation;
        this.strategy = strategy;
    }
    serialization(stream) {
        this.controllerUid = stream.uid(this.controllerUid);
        this.selectionOrigin = stream.number3(this.selectionOrigin);
        this.selectionRotation = stream.number4(this.selectionRotation);
        super.serialization(stream);
    }
    static is(msg) {
        return msg.type === SetSelectionStrategyMessage.typestatic;
    }
}
SetSelectionStrategyMessage.typestatic = "SetSelectionStrategyMessage";
SetSelectionStrategyMessage.subjectstatic = "selection";
MessageFactory.register(SetSelectionStrategyMessage);
export class SetSelectionStrategyForHandsMessage extends SetSelectionStrategyBaseMessage {
    get byteLength() {
        return calcArrayByteLength(this.hands) + super.byteLength;
    }
    constructor(hands, strategy) {
        super();
        this.hands = hands;
        this.strategy = strategy;
    }
    serialization(stream) {
        this.hands = stream.array(this.hands);
        super.serialization(stream);
    }
    static is(msg) {
        return msg.type === SetSelectionStrategyForHandsMessage.typestatic;
    }
}
SetSelectionStrategyForHandsMessage.typestatic = "SetSelectionStrategyForHandsMessage";
SetSelectionStrategyForHandsMessage.subjectstatic = "selection";
MessageFactory.register(SetSelectionStrategyForHandsMessage);
/**
 * Enables or disables controller-based selection.
 */
export class EnableControllerSelectionMessage extends BusMessage {
    get byteLength() {
        return BOOLEAN_BYTES_PER_ELEMENT + UID_SAFE_BYTES_PER_ELEMENT;
    }
    constructor(enabled, uid) {
        super();
        this.enabled = enabled;
        this.uid = uid;
    }
    serialization(stream) {
        this.enabled = stream.boolean(this.enabled);
        this.uid = stream.uidSafe(this.uid);
    }
    static is(msg) {
        return msg.type === EnableControllerSelectionMessage.typestatic;
    }
}
EnableControllerSelectionMessage.typestatic = "EnableSelectionMessage";
EnableControllerSelectionMessage.subjectstatic = "selection";
MessageFactory.register(EnableControllerSelectionMessage);
/**
 * Controls controller ray selection and whether its ray is rendered.
 */
export class SetRaycastSettingsMessage extends BusMessage {
    get byteLength() {
        return BOOLEAN_BYTES_PER_ELEMENT * 2;
    }
    constructor(raycastEnabled, visualizationEnabled) {
        super();
        this.raycastEnabled = raycastEnabled;
        this.visualizationEnabled = visualizationEnabled;
    }
    serialization(stream) {
        this.raycastEnabled = stream.boolean(this.raycastEnabled);
        this.visualizationEnabled = stream.boolean(this.visualizationEnabled);
    }
    static is(msg) {
        return msg.type === SetRaycastSettingsMessage.typestatic;
    }
}
SetRaycastSettingsMessage.typestatic = "SetRaycastSettingsMessage";
SetRaycastSettingsMessage.subjectstatic = "selection";
MessageFactory.register(SetRaycastSettingsMessage);
/**
 * Enables or disables model selection in general.
 */
export class EnableModelSelectionMessage extends BusMessage {
    get byteLength() {
        return UID_SAFE_BYTES_PER_ELEMENT + BOOLEAN_BYTES_PER_ELEMENT;
    }
    constructor(uid, enabled) {
        super();
        this.uid = uid;
        this.enabled = enabled;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
        this.enabled = stream.boolean(this.enabled);
    }
    static is(msg) {
        return msg.type === EnableModelSelectionMessage.typestatic;
    }
}
EnableModelSelectionMessage.typestatic = "EnableModelSelectionMessage";
EnableModelSelectionMessage.subjectstatic = "selection";
MessageFactory.register(EnableModelSelectionMessage);
/**
 * Clears selection state for one input device.
 */
export class ClearSelectionForInputDeviceMessage extends BusMessage {
    get byteLength() {
        return UID_BYTES_PER_ELEMENT;
    }
    constructor(controllerUid) {
        super();
        this.controllerUid = controllerUid;
    }
    serialization(stream) {
        this.controllerUid = stream.uid(this.controllerUid);
    }
    static is(msg) {
        return msg.type === ClearSelectionForInputDeviceMessage.typestatic;
    }
}
ClearSelectionForInputDeviceMessage.typestatic = "ClearSelectionForInputDeviceMessage";
ClearSelectionForInputDeviceMessage.subjectstatic = "selection";
MessageFactory.register(ClearSelectionForInputDeviceMessage);
/**
 * Announces a model selection change.
 */
export class ModelSelectMessage extends BusMessage {
    get byteLength() {
        return (UID_BYTES_PER_ELEMENT + // controllerUid
            UID_BYTES_PER_ELEMENT + // uid
            BOOLEAN_BYTES_PER_ELEMENT); // isSelected
    }
    constructor(controllerUid, uid, isSelected) {
        super();
        this.controllerUid = controllerUid;
        this.uid = uid;
        this.isSelected = isSelected;
    }
    serialization(stream) {
        this.controllerUid = stream.uid(this.controllerUid);
        this.uid = stream.uid(this.uid);
        this.isSelected = stream.boolean(this.isSelected);
    }
    static is(msg) {
        return msg.type === ModelSelectMessage.typestatic;
    }
}
ModelSelectMessage.typestatic = "ModelSelectMessage";
ModelSelectMessage.subjectstatic = "general";
MessageFactory.register(ModelSelectMessage);
